import {
  FailClosedReleaseFactory,
  Release,
  ReleaseReadModel
} from "featureFlags/domain/release"

export class EnvVarReleaseReadModel implements ReleaseReadModel {
  private readonly source: Record<string, unknown>
  private readonly releases = new FailClosedReleaseFactory()

  constructor(environment: Record<string, unknown>) {
    this.source = environment
  }

  getByName = (flagName: string): Release =>
    this.releases.fromFlagValue(this.source[flagName])
}

export class CombinedSourcesReleaseReadModel implements ReleaseReadModel {
  private readonly localStorage: Storage
  private readonly environment: Record<string, unknown>
  private readonly releases = new FailClosedReleaseFactory()

  constructor(localStorage: Storage, environment: Record<string, unknown>) {
    this.localStorage = localStorage
    this.environment = environment
  }

  getByName = (flagName: string): Release => {
    const override = this.localStorage.getItem(flagName)

    if (override) {
      return this.releases.fromFlagValue(override)
    } else {
      return this.releases.fromFlagValue(this.environment[flagName])
    }
  }
}
